<template>
  <div class="waiting-credentials-card" :class="{ loading }">
    <div v-if="pending">
      <div class="waiting-card-header">החיבור לבנק לא הושלם</div>
      <div class="bank-description">
        <img class="pending-icon" :src="require('@/assets/pending-icon.svg')"/>
        <div class="bank-title">בנק {{ source.displayName }}</div>
      </div>
      <div class="nickname">{{ source.name }}</div>
    </div>

    <div v-else>
      <div class="bank-description invalid">
        <div class="bank-title">בנק {{ source.displayName }}</div>
      </div>
      <div class="nickname invalid">{{ source.name }}</div>
    </div>

    <div class="actions">
      <riseup-button v-if="pending" :variant="'secondary'" :title="'נסו שוב באתר דיסקונט'" :action="redirectToGetAccessCode" />
      <riseup-button v-else :variant="'primary'" :title="'נסו שוב באתר דיסקונט'" :action="redirectToGetAccessCode" />
      <div class="switch-to-old-connection" v-on:click="connectWithPassword">להתחברות עם שם משתמש וסיסמה</div>
    </div>
    <bank-footer :source="source" />
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex';
import BaseUI from 'base-ui';
import DiscountApi from '../../../../api/DiscountApi';
import effects from '../../../../store/utilities/effects';
import Segment from '../../../../Segment';
import BankFooter from '../BankFooter.vue';

export default {
  name: 'WaitingCredentialsCard',
  components: {
    RiseupButton: BaseUI.RiseupButton,
    BankFooter,
  },
  props: [
    'source',
  ],
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState('sourceFields', ['allSourceFields']),
    pending() {
      return this.source.status === 'pending';
    },
  },
  methods: {
    ...mapActions('credentials', ['createCredentials', 'deleteCredentials']),
    async redirectToGetAccessCode() {
      Segment.trackUserInteraction('TryAgainInDiscountClicked', { credentialsId: this.source.credentialsId });
      const connectionState = await DiscountApi.getConnectionState(this.source.credentialsId);
      if (!connectionState) {
        throw new Error('No pending connection could be found for customer');
      }
      const url = await DiscountApi.getAccessCodeUrl(connectionState.identificationNumber, this.source.credentialsId);
      window.location.href = url;
    },
    async connectWithPassword() {
      this.loading = true;
      Segment.trackUserInteraction('ConnectDiscountWithPasswordClicked', { credentialsId: this.source.credentialsId });
      const newCredentialsId = await this.createCredentials({ sourceName: this.allSourceFields.discount.sourceName });
      await effects.scrollToElement(newCredentialsId);
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../scss/mixins';

  .waiting-credentials-card {
    font-family: SimplerPro;
    width: 100%;
    border-radius: 3px;
    box-shadow: 2px 2px 8px 0 $riseup_gray_1;

    &.loading {
      opacity: 0.5;
      pointer-events: none;
    }

    .waiting-card-header {
      display: inline-block;
      width: 100%;
      height: 42px;
      line-height: 42px;
      font-size: 14px;
      background-color: $riseup_mustard;
      color: $riseup_white;
      font-weight: bold;
      padding-right: 20px;
    }

    .bank-description {
      padding-top: 24px;
      display: flex;

      .pending-icon {
        margin: 0 15px;
      }

      .bank-title {
        @include card-title;
      }

      &.invalid {
        margin-right: 30px;
      }
    }

    .nickname {
      margin-right: 50px;
      margin-top: 8px;
      font-size: 20px;

      &.invalid {
        margin-right: 30px;
      }
    }

    .actions {
      padding: 30px;
      text-align: center;

      .riseup-button {
        width: 100%;
      }

      .switch-to-old-connection {
        margin-top: 30px;
        color: $riseup_light_blue;
        font-weight: bold;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
</style>
